import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'companies/profitcenter';
const model = 'companies/profitCenter';
const modelExposedName = 'Profit Center';
const wizardAction = 'create';

const Create = (params) => {

    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);

    const [drawable, setDrawable] = useState(false);
    const { doAction, item, loadOne, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.stack);

    const detailConfig = {
        "tabs": [
            {
                "name": "create_new_profit_center",
                "fieldsets": [
                    {
                        "name": "profitcenter_information",
                        "fields": {
                            "name": {
                                "type": "text",
                                "required": true,
                                "className": "col-6",
                                "icon": "faInputText"
                            },
                            "status": {
                                "type": "select",
                                "options": [
                                    {
                                        "label": "active",
                                        "value": "active"
                                    },
                                    {
                                        "label": "inactive",
                                        "value": "inactive"
                                    }
                                ],
                                "required": true,
                                "className": "col-6",
                                "icon": "faChartPyramid"
                            },
                            "disabled_at": {
                                "type": "date",
                                "className": "col-12",
                                "icon": "faCalendarXmark",
                                "visibilitycondition": [
                                    [
                                        "status",
                                        "=",
                                        "inactive"
                                    ]
                                ]
                            },
                            "legalEntity": {
                                "type": "relationshipSingle",
                                "required": true,
                                "relation": {
                                    "drawerRoute": "legalentities",
                                    "inverseRelation": "profitCenter",
                                    "inverseRelationType": "relationshipSingle",
                                    "filter": {
                                        "items": [
                                            {
                                                "field": "type",
                                                "operator": "equals",
                                                "value": "customer"
                                            }
                                        ]
                                    }
                                },
                                "view": "legalEntity",
                                "label": "customer"
                            },
                            "businessUnits": {
                                "type": "relationship",
                                "relation": {
                                    "drawerRoute": "businessunits",
                                    "inverseRelation": "profitCenter",
                                    "inverseRelationType": "relationship"
                                },
                                "view": "businessUnit"
                            }
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    useEffect(() => {
        loadOne(null).then(e => setDrawable(true));
    }, []);

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <>
                <DetailComponent
                    values={{
                        ...item?.data,
                        status: item?.data?.status ?? 'active',
                        legalEntity: discover('legalEntity') ?? discover('car.legalEntity') ?? discover('employment.legalEntity'),
                    }}
                    modelName={model.split('/')[1]}
                    detailConfig={detailConfig}
                    dataProviderName={dataProviderName}
                    onEditing={setEditing}
                    save={handleSave}
                    saving={saving}
                    errors={errors}
                    errorMessage={errorMessage}
                    title={t('New {{itemname}}', { itemname: t(modelExposedName) })}
                    canSave={userCapabilities && userCapabilities[dataProviderName + '.create']}
                    header={
                        <InfoHeader
                            view="wizard"
                            title={t('Create new {{itemname}}', { itemname: t(modelExposedName) })}
                            subtitle={t('Fill the basic information to create a new {{itemname}} that you will be able to edit via the standard interface', { itemname: t(modelExposedName) })}
                        />
                    }
                    {...params}
                />
            </>
    )
}

export default Create;